import { useEffect, useContext } from "react";
import { saveUserUsage } from '../Services/action.js';
import { DataContext } from './DataContext.js';



const AppTracking = ({ pageName }) => {
    const { data } = useContext(DataContext);
    const newData = { ...data };
    useEffect(() => {
        track();
    }, []);
    const track = () => {
        saveUserUsage({ mobileNo: newData.mobileNumber, eventId: newData.eventId, pageVisited: pageName })
            .then((data) => {
            })
            .catch((error) => {
            });

    };
    return (
        <>

        </>
    );
};

export default AppTracking;